import { isAppTypeIframe } from "../getAppType";
import { useSettings } from "../settings/useSettings";
import { getRedirectProps, IGetRedirectPropsResponse } from "./redirect";

// This is used to redirect the user to the correct page after a attach-profile token has been sent
export function useLoginProps(): LoginProps {
  const settings = useSettings();

  if (isAppTypeIframe() && settings.iframe_loginOldPortal) {
    return {
      type: "iframeLegacyLogin",
      redirectProps: {
        href: `https://secure.webtemp.no/WebtempCVPortal/default.aspx?k=${window.cvpIdConcern}`,
        target: "_blank",
      },
    };
  }

  if (isAppTypeIframe()) {
    return {
      type: "iframeLogin",
      redirectProps: getRedirectProps("/login", {
        mergeQs: {},
      }),
    };
  }

  let redirectUri = location.pathname;

  if (redirectUri === "/login") {
    redirectUri = "/";
  }

  if (window.cvpIdConcern) {
    redirectUri += `?k=${window.cvpIdConcern}`;
  }

  const searchParams = new URLSearchParams();
  searchParams.set("redirectUri", redirectUri);

  return {
    type: "normal",
    redirectProps: {
      href: `/auth/visma-connect/login?${searchParams.toString()}`,
    },
  };
}

export interface LoginProps {
  type: "iframeLogin" | "iframeLegacyLogin" | "normal";
  redirectProps: IGetRedirectPropsResponse;
}
